/**
 * Utility to clean up old localStorage keys from the previous DataContext implementation
 * This should be called once on app startup to migrate users from old to new storage format
 */

/**
 * Clears all old couponData_* localStorage keys
 * These were used by the old DataContext implementation
 */
export const clearOldLocalStorageKeys = () => {
  try {
    const keysToRemove = [
      'couponData_step1',
      'couponData_step2',
      'couponData_step3',
      'couponData_step4',
      'couponData_step5',
      'couponData_step6',
      'couponData_step7',
      'couponData_step8',
      'couponData_payment',
      'couponData_companyId',
      'couponData_couponId',
      'couponData_userCountry',
      'couponData_selectedDeal'
    ];

    keysToRemove.forEach(key => {
      try {
        localStorage.removeItem(key);
        console.log(`Cleaned up old localStorage key: ${key}`);
      } catch (error) {
        console.warn(`Failed to remove localStorage key ${key}:`, error);
      }
    });

    console.log('Old localStorage keys cleanup completed');
    return true;
  } catch (error) {
    console.error('Error during localStorage cleanup:', error);
    return false;
  }
};

/**
 * Checks if old localStorage keys exist
 * @returns {boolean} True if any old keys are found
 */
export const hasOldLocalStorageKeys = () => {
  try {
    const oldKeyPrefix = 'couponData_';
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith(oldKeyPrefix)) {
        return true;
      }
    }
    return false;
  } catch (error) {
    console.error('Error checking for old localStorage keys:', error);
    return false;
  }
};

/**
 * Clear old affiliate from localStorage when user lands on the main landing (no affiliate in URL).
 * So a new affiliate link can set a fresh one and an old one doesn't cling.
 */
export const clearAffiliateOnLandingIfNeeded = () => {
  try {
    const pathname = typeof window !== 'undefined' ? window.location.pathname : '';
    if (pathname === '/' || pathname === '/price-plan') {
      localStorage.removeItem('deliva_affiliate_code');
    }
  } catch (error) {
    console.warn('Could not clear affiliate on landing:', error);
  }
};

/**
 * Runs cleanup on app startup if old keys are detected
 * This is a safe operation that won't affect the new wizardData storage
 */
export const runStartupCleanup = () => {
  clearAffiliateOnLandingIfNeeded();
  if (hasOldLocalStorageKeys()) {
    console.log('Old localStorage keys detected, running cleanup...');
    clearOldLocalStorageKeys();
  }
};
